export default {
  toasts: {
    load_error: 'Failed to load the fee rates',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes saved',
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  rates: {
    title: 'Processing margin',
    description:
      'Percentage in %, plus an optional fixed and minimum amount per charge. “Any payment method” applies when no method-specific rate exists.',
    default: {
      inherits:
        'No Adyen rate is set, so this partner’s restaurants on FoodAmigos’ Adyen pay the FoodAmigos default below. A rate you set here replaces it; a rate set on a single restaurant still takes precedence.',
      overridden:
        'This partner’s own Adyen rate replaces the FoodAmigos default below for its restaurants on FoodAmigos’ Adyen. Remove it to fall back to the default.',
      own_adyen:
        'This partner processes on its own Adyen account. Its restaurants pay no processing fee unless a rate is set here or on a single restaurant.',
      master:
        'These are the FoodAmigos default rates. Every partner on FoodAmigos’ Adyen without an Adyen rate of its own uses them.',
      rows_title: 'FoodAmigos default rates',
    },
  },
};
